function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8892c5",
  d: "M26 30.8l897.5.5",
  opacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8892c5",
  d: "M26.5 0v80m53-80v80m106-80v80m105-80v80m105-80v80m106-80v80m105-80v80m106-80v80m105-80v80m-685-80v80m105-80v80m106-80v80m105-80v80m106-80v80m105-80v80m105-80v80m106-80v80",
  opacity: 0.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8892c5",
  d: "M923.5 0v200"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fb7d74",
  d: "M67 0v200"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#8892c5",
  fontFamily: "Montserrat-Medium",
  fontSize: 20
}, React.createElement("text", {
  transform: "translate(0 107)"
}, "2019"), React.createElement("text", {
  transform: "translate(110 107)"
}, "2021"), React.createElement("text", {
  transform: "translate(213 107)"
}, "2023"), React.createElement("text", {
  transform: "translate(319 107)"
}, "2025"), React.createElement("text", {
  transform: "translate(423 107)"
}, "2027"), React.createElement("text", {
  transform: "translate(529 107)"
}, "2029"), React.createElement("text", {
  transform: "translate(633 107)"
}, "2031"), React.createElement("text", {
  transform: "translate(742 107)"
}, "2033"), React.createElement("text", {
  transform: "translate(847 107)"
}, "2035"));

var _ref7 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Medium",
  fontSize: 20,
  transform: "translate(37 227)"
}, "Today");

var _ref8 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#8892c5",
  fontFamily: "Montserrat-Medium",
  fontSize: 20,
  transform: "translate(900 227)"
}, "2036");

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(32 38)"
}, React.createElement("path", {
  id: "desktop-a",
  fill: "#6fdc8b",
  d: "M36.8 47.1l-3.6-3.6-1.2 1.2 4.8 4.8 10.3-10.3-1.2-1.2z"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#6fdc8b",
  fillRule: "evenodd",
  d: "M30 30h20v3H30z",
  clipRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h20v3H0z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M104 0h20v3h-20z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M210 0h20v3h-20z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M315 0h20v3h-20z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M421 0h20v3h-20z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M527 0h20v3h-20z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M631 0h20v3h-20z",
  transform: "translate(137 30)"
}), React.createElement("path", {
  d: "M737 0h20v3h-20z",
  transform: "translate(137 30)"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff",
  fontFamily: "Montserrat-Medium",
  fontSize: 14
}, React.createElement("text", {
  transform: "translate(137 22)"
}, "87th"), React.createElement("text", {
  transform: "translate(30 22)"
}, "86th"), React.createElement("text", {
  transform: "translate(241 22)"
}, "88th"), React.createElement("text", {
  transform: "translate(346 22)"
}, "89th"), React.createElement("text", {
  transform: "translate(452 22)"
}, "90th"), React.createElement("text", {
  transform: "translate(558 22)"
}, "91st"), React.createElement("text", {
  transform: "translate(663 22)"
}, "92nd"), React.createElement("text", {
  transform: "translate(768 22)"
}, "93rd"), React.createElement("text", {
  transform: "translate(874 22)"
}, "94th"));

var SvgS6DesktopColors = function SvgS6DesktopColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 948 233",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default "data:image/svg+xml;base64,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";
export { SvgS6DesktopColors as ReactComponent };